import React, { useEffect, useState } from "react";
import { Grid, Segment, Table } from "semantic-ui-react";
import BookedSlotsTable from "./BookedSlotsTable";
import NoticeBoard from "./NoticeBoard";
// import { ApiEndPoint } from "/src/_helper/constant/api-types";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
// import NavBar from "../../admin/homecomponents/NavBar";
// import Navbar from "./Navbar";
// import BookAppointment from "./BookAppointment";
// import CurrentPatient from "./CurrentPatient";
// import NextPatient from "./NextPatient";
import { useItemsFilter } from "../../../_helper/actions/app/items";
import {
  DateToyyyymmdd,
  checkTimeSlot,
  convertToCustomFormat,
} from "../../../_helper/utils/utils";
import { clinicTiming } from "../../admin/templete/atom/layoutatom";
import { useAtom } from "jotai";
import { clinicAtom } from "../../../_helper/constant/constant-atom";
import moment from "moment";
import { useCurrentRole } from "../../../_helper/constant/Permission";
import { WEBSOCKET_URL } from "../../../_helper/constant/constant";

export default function Layout() {
  const englishquotes = [
    "Stay hydrated, it's the foundation of good health.",
    "Take a daily walk. your heart will thank you.",
    "A good laugh is a naturalstress-buster; embrace joy daily.",
  ];
  const marathiQuotes = [
    "पर्याप्त पाण्य प्यायला ठरवा, हे आरोग्याच्या शिलेचा मुळ आहे.",
    "प्रतिदिनचा सातत्यपूर्ण प्रवास करा. तुमचं हृदय तुमची कृतज्ञता करेल.",
    "एक चांगलं हसणं प्राकृतिक तंतून स्ट्रेस-बस्टर आहे.",
  ];

  const hindiQuotes = [
    "हमेशा पानी पीना, यह स्वस्थ जीवन का आधार है।",
    "रोज़ाना टहलीलगाड़ी करें। आपके ह्रदय का आभारी रहेगा।",
    "एक अच्छा हंसी मनोबल-बढ़ाने वाला है; प्रतिदिन आनंद को अपनाओ।",
  ];
  const [allslots, setAllSlots] = useState([]);
  const [quote, setQuote] = useState(englishquotes);
  // const [query, setQuery] = useState("");
  const [clinic] = useAtom(clinicAtom);
  const { role_id } = useCurrentRole();

  const filter = `?action=getTvViewPermissions&backend=True&clinic_id=${clinic?.id}`;
  const { data: clinicData } = useItemsFilter(
    ApiEndPoint.CLINIC,
    filter,
    clinic ? true : false
  );

  // //("clininc data-----", clinicData ? clinicData[0]?.note : "");

  // const { data: tvViewPermissions } = useItemsFilter(
  //   "tv_view_permissions",
  //   `?filter[clinic_id][_eq]=${clinic?.id}&fields=id,fields,timing`,
  //   clinic?.id ? true : false
  // );

  // const now = new Date();
  // const currentTime = now.getHours() * 100 + now.getMinutes();

  let startTime;
  let endTime;
  if (clinicData?.length > 0) {
    if (clinicData[0]?.timing?.flag?.auto) {
      const { start_time, end_time } = checkTimeSlot();
      // //()
      startTime = convertToCustomFormat(start_time);
      endTime = convertToCustomFormat(end_time);
    } else {
      startTime = convertToCustomFormat(
        clinicData[0]?.timing?.timing?.start_time
      );
      endTime = convertToCustomFormat(clinicData[0]?.timing?.timing?.end_time);
    }
  }
  // if (currentTime < 1800) {
  //   startTime = `${DateToyyyymmdd(new Date(), -1)}T18:30:00`;
  //   endTime = `${DateToyyyymmdd(new Date(), 0)}T08:30:00`;
  // } else {
  //   startTime = `${DateToyyyymmdd(new Date(), 0)}T08:30:00`;
  //   endTime = `${DateToyyyymmdd(new Date(), 0)}T18:00:00`;
  // }

  // //(startTime, endTime);

  const query = `?action=getAllSlots&clinic_id=${
    clinic?.id
  }&backend=True&date=${moment(startTime).format(
    "YYYY-MM-DDTHH:mm:ss[Z]"
  )}to${moment(endTime).format("YYYY-MM-DDTHH:mm:ss[Z]")}&doctor_id=${role_id}`;

  const {
    data: slotsData,
    isSuccess,
    isFetched,
    isLoading,
    refetch,
  } = useItemsFilter(
    ApiEndPoint.QM_SC_SLOTS,
    query,
    clinic?.id && role_id && startTime && endTime ? true : false
  );

  const HandleQuoteChange = (value) => {
    switch (value) {
      case "english":
        setQuote(englishquotes);
        break;
      case "marathi":
        setQuote(marathiQuotes);
        break;
      case "hindi":
        setQuote(hindiQuotes);
        break;
      default:
        setQuote(englishquotes);
    }
  };

  const wsUrl = role_id ? `${WEBSOCKET_URL}ws/app/${role_id}/` : null;

  useEffect(() => {
    if (!wsUrl) {
      return;
    }

    const ws = new WebSocket(wsUrl);

    ws.onopen = () => {
      //("WebSocket connection opened.");
    };

    ws.onmessage = (event) => {
      const receivedData = JSON.parse(event.data);
      //("Message received from server:", receivedData?.message?.data);
      // setData(receivedData?.message?.data);
      refetch();
    };

    ws.onerror = (error) => {
      //("WebSocket error:", error);
    };

    ws.onclose = () => {
      //("WebSocket connection closed.");
    };

    // Cleanup function to close the WebSocket connection when the component unmounts
    return () => {
      ws.close();
    };
  }, [wsUrl, clinic, role_id]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     refetch();
  //   }, 10000);

  //   return () => {
  //     clearInterval(intervalId); // Clean up the interval on component unmount
  //   };
  // }, []);
  // //("SLOTS DATA GET", slotsData);
  const lst = [];
  const cabinNumbers = {};
  // //("data is this", slotsData);
  useEffect(() => {
    const sortedData = slotsData?.booked_slots?.sort((a, b) => {
      // Convert date_created strings to Date objects for comparison
      const dateA = new Date(a.start_time);
      const dateB = new Date(b.start_time);
      return dateA - dateB;
    });
    sortedData?.map((ele, idx) => {
      // //(ele);
      const formattedDate = new Date(`${ele?.start_time}Z`).toLocaleDateString(
        "en-GB",
        {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }
      );

      const doctorName = `${ele.doctor_user.first_name} ${ele.doctor_user.last_name}`;

      if (!cabinNumbers[doctorName]) {
        // If the doctor's cabin number is not assigned, assign a new one
        cabinNumbers[doctorName] = Object.keys(cabinNumbers).length + 1;
      }

      lst.push({
        Name: ele?.user_details?.full_name,
        Time: moment.utc(ele?.start_time).utcOffset("+05:30").format("hh:mm A"),
        Consulting_Doctor: doctorName, // Use doctorName variable here
        Date: formattedDate,
        Status: ele?.status.charAt(0).toUpperCase() + ele?.status.slice(1),
        Token: idx + 1,
        Cabin_Number: cabinNumbers[doctorName],
        time_dt: new Date(ele?.start_time),
      });
    });
    // const currentDate = new Date();
    // currentDate.setHours(currentDate.getHours() - 5);
    // currentDate.setMinutes(currentDate.getMinutes() - 30);
    // const last_data = lst?.filter((el) => (el?.Status === "Booked"&& el.time_dt>=currentDate));
    const last_data = lst?.filter((el) => el?.Status === "Booked");

    setAllSlots(last_data);
  }, [slotsData, isSuccess, isFetched]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      {/* <Navbar /> */}
      <div className="w-full h-[128px] flex justify-between items-center bg-[#DEF6E0] px-5">
        <div className="w-[255px] h-[117px] flex justify-center items-center">
          <img src="" alt="logo..." />
        </div>
        <div className="text-2xl font-bold">Welcome to {clinic?.name}</div>
        <div className="text-2xl font-bold">
          {moment(new Date()).format("DD MMM yyyy")}
        </div>
      </div>
      <BookedSlotsTable data={allslots} tvViewPermissions={clinicData} />
      {/* <NoticeBoard quote={quote} /> */}
      <div className="h-[163px] w-full text-center bg-[#DEF6E0] p-2 flex flex-col justify-between items-center">
        <div className="text-xl font-bold">NOTICE</div>
        <div
          className="text-2xl font-bold"
          dangerouslySetInnerHTML={{
            __html: clinicData ? clinicData[0]?.note : "",
          }}
        />
        <div className="text-xl">
          Please bring previous prescription for follow-up visit.Please maintain
          silence.
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          // marginBlockStart: "1rem",
        }}
      >
        <p>Select Language :</p>
        <p
          onClick={() => HandleQuoteChange("english")}
          style={{
            cursor: "pointer",
            color:
              quote.toString() === englishquotes.toString()
                ? "#319eff"
                : "#292929",
          }}
        >
          <i class="united kingdom flag"></i>
          English
        </p>
        <p
          onClick={() => HandleQuoteChange("hindi")}
          style={{
            cursor: "pointer",
            color:
              quote.toString() === hindiQuotes.toString()
                ? "#319eff"
                : "#292929",
          }}
        >
          <i class="india flag"></i>
          Hindi
        </p>
        <p
          onClick={() => HandleQuoteChange("marathi")}
          style={{
            cursor: "pointer",
            color:
              quote.toString() === marathiQuotes.toString()
                ? "#319eff"
                : "#292929",
          }}
        >
          <i class="india flag"></i>
          Marathi
        </p>
      </div>
    </div>
  );
}
